import { space } from '../tokens';
import { style } from '../layer.css';

export const toastRoot = style({
  display: 'flex',
  alignItems: 'center',
  gap: space.s12,
});

export const toastIcon = style({
  display: 'flex',
  flexShrink: 0,
});

export const toastMessage = style({
  display: 'flex',
  flexGrow: 1,
  flexDirection: 'column',
  gap: space.s4,
});

export const toastActions = style({
  marginLeft: space.s28,
  display: 'flex',
  gap: space.s12,
  alignItems: 'center',
});
